import { User } from "../../models/index";
import { formatDate } from "../../utils/formatDate";
import { Avatar } from "../atoms/Avatar";
import { Card } from "../atoms/card";
import { Review } from "../../types";

import { StarRating } from "./StarRating";
import toAmbiguousAge from "../../utils/ambiguousAge";

interface UserInfoProps {
  user: User;
}

const UserInfo = ({ user }: UserInfoProps) => {
  const ambiguousAge = toAmbiguousAge(user?.birthday);
  return (
    <>
      {ambiguousAge ? `${ambiguousAge}代・` : ""}
      {user.ambiguousAge && user.gender ? `・` : ""}
      {user.gender ? user.gender : ""}
    </>
  );
};

interface Props {
  review: Review;
  className?: string;
}

export const ReviewCard = ({ review, className }: Props) => {
  return (
    <Card elevation={3} tw="rounded-lg w-full" className={className}>
      <div tw="flex items-center border-b border-solid border-gray p-3">
        <Avatar src={review?.user?.imageUrl} size={37} blur={2} />
        <div tw="ml-3">
          <div tw="font-base text-[11px] tracking-[.32px] leading-[11px] mb-2">
            {!review?.user?.ambiguousAge && !review?.user?.gender ? (
              <span>匿名</span>
            ) : (
              <UserInfo user={review?.user} />
            )}
          </div>
          <StarRating rate={review.score} size="small" />
        </div>
        <div tw="font-base font-normal text-2xs tracking-[-0.3px] leading-[10px] text-secondary ml-auto">
          {formatDate(review.createdAt)}
        </div>
      </div>
      <p tw="font-base font-light text-xs leading-5 tracking-[.29px] p-3 text-left">
        {review.content}
      </p>
    </Card>
  );
};
